import React from "react";
import PropTypes from "prop-types";
import { H1, P } from "orcs-design-system";

import { copywriting } from "src/components/ErrorPage/ErrorPage.config";
import ErrorPageWrapper from "./ErrorPageWrapper";

const ContentTooLargeError = ({ showHeader, showContainer }) => {
  return (
    <ErrorPageWrapper
      showHeader={showHeader}
      showContainer={showContainer}
      showBackButton
      showSupportButton
      showLogoutButton={false}
    >
      <H1>{copywriting.contentTooLargeErrorHeading}</H1>
      <P>{copywriting.contentTooLargeErrorDetail}</P>
    </ErrorPageWrapper>
  );
};

ContentTooLargeError.propTypes = {
  showHeader: PropTypes.bool,
  showContainer: PropTypes.bool,
};

export default ContentTooLargeError;
